import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Col, Menu, Row, Space } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import BottomSheet from "../../components/BottomSheet";
import Logout from "../../components/Logout";
import AvatarPreview from "../profile/components/AvatarPreview";
import { signOut } from "../../actions/profile";
import { ReactComponent as HelpIcon } from "../../images/help_center.svg";

function MenuPage() {
  const [state, setstate] = useState({ bottomSheet: false });
  const [profile, setProfile] = useState({});
  const dispatch = useDispatch();
  const {
    loading,
    data: profileData = {
      username: "",
    },
  } = useSelector((state) => state.profile);

  function toggleBottomSheet() {
    setstate((prev) => ({ ...prev, bottomSheet: !prev.bottomSheet }));
  }

  function logout() {
    dispatch(signOut());
    toggleBottomSheet();
  }

  useEffect(() => {
    if (
      !loading &&
      profileData != null &&
      profileData.hasOwnProperty("extraInfo") &&
      profileData.extraInfo != null
    ) {
      setProfile({ data: profileData });
    }
  }, [loading, profileData]);

  useEffect(() => {
    const profileStr = sessionStorage.getItem("red-profile");

    if (profileStr && profileStr.length) {
      setProfile(JSON.parse(profileStr));
    }
  }, []);

  return (
    <div className="wrap-menu">
      <div className="user-info pt-20 pb-20">
        <Row>
          <Col span={20} offset={2}>
            <Space size={16}>
              <div className="ant-card-meta-avatar">
                <Avatar
                  src={
                    <AvatarPreview
                      src={profile?.data?.extraInfo?.avatarImageUrl}
                    />
                  }
                />
              </div>
              <span className="ant-card-meta-title">
                نام کاربری:{" "}
                {profile.hasOwnProperty("data") &&
                profile.data != null &&
                profile.data.hasOwnProperty("extraInfo") &&
                profile.data.extraInfo != null &&
                profile.data.extraInfo.hasOwnProperty("firstName")
                  ? profile.data.extraInfo.firstName
                  : profile.hasOwnProperty("data") &&
                    profile.data.hasOwnProperty("username")
                  ? profile.data.username
                  : "-"}
              </span>
            </Space>
          </Col>
        </Row>
      </div>

      <Menu
        style={{ width: 256 }}
        defaultSelectedKeys={["1"]}
        defaultOpenKeys={["sub1"]}
        mode="inline"
        className="wrap-menu-items"
      >
        <Menu.ItemGroup key="g1" title={null}>
          <Menu.Item key="1" icon={<span className="icon-menu-profile" />}>
            <Link to="/profile">پروفایل</Link>
          </Menu.Item>
          <Menu.Item key="2" icon={<span className="icon-menu-setting" />}>
            <Link to="/setting"> تنظیمات</Link>
          </Menu.Item>
          <Menu.Item key="3" icon={<span className="icon-menu-wallet" />}>
            <Link to="/transactions">صورت حساب و افزایش اعتبار</Link>
          </Menu.Item>
          <Menu.Item key="4" icon={<InfoCircleOutlined />}>
            <Link to="faq"> سوالات متداول</Link>
          </Menu.Item>
          {/* <Menu.Item key="5" icon={<span className="icon-menu-news-blog" />}>
            <Link to="/blog">اخبار و بلاگ</Link>
          </Menu.Item> */}
          <Menu.Item key="5" icon={<HelpIcon />}>
            <Link to="/help">راهنمای استفاده از اپلیکیشن</Link>
          </Menu.Item>
          <Menu.Item key="6" icon={<span className="icon-menu-support" />}>
            <Link to="support">پشتیبانی</Link>
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.ItemGroup key="g2" title={null}>
          <Menu.Item key="7" icon={<span className="icon-menu-about" />}>
            <Link to="/about-us">درباره اپلیکیشن</Link>
          </Menu.Item>
          <Menu.Item
            key="8"
            onClick={toggleBottomSheet}
            icon={<span className="icon-menu-log-out" />}
          >
            <span className="menu-item-link">خروج</span>
          </Menu.Item>
        </Menu.ItemGroup>
      </Menu>
      <BottomSheet
        className="wrap-logout"
        classNames=" backdrop-blur"
        isOpen={state.bottomSheet}
        setClose={toggleBottomSheet}
      >
        <Logout close={toggleBottomSheet} logout={logout} />
      </BottomSheet>
    </div>
  );
}

export default MenuPage;
